import React from 'react';
import { Grid } from '@mui/material';
import { dracula } from '@uiw/codemirror-theme-dracula';
import { javascript } from '@codemirror/lang-javascript';
import CodeMirror from '@uiw/react-codemirror';
import { tqlEditorStyles, TQLEditorStyles } from './tql-editor-helper';

interface TQLEditorProps {
    tqlCode: string;
    onTQLCodeChange: (code: string) => void;
}

export const TQLEditor = ({
    tqlCode,
    onTQLCodeChange,
}: TQLEditorProps): React.JSX.Element => {
    return (
        <Grid sx={tqlEditorStyles.tqlEditorInnerContainer}>
            <CodeMirror
                value={tqlCode}
                style={tqlEditorStyles.tqlEditor}
                extensions={[javascript({ jsx: true }), TQLEditorStyles]}
                theme={dracula}
                onChange={onTQLCodeChange}
            />
        </Grid>
    );
};
